import React from "react";
import '../../../theme/common/styles.scss';

export const Input = ({
  input,
  label,
  meta: { touched, error },
  config,
  placeholder,
  widthStyle,
  style,
  data,
  type,
  ...props
}) => {
  widthStyle = widthStyle ? widthStyle : "col-md-12";
  const validationSpan =
    touched && error ? (
      <span className="error_msg text-danger">{error}</span>
    ) : null;

  return (
    <div className={widthStyle}>
      <div className="form-group" style={style}>
        {label && <label>{label}</label>}
        <input className="form-control"
          type={type}
          placeholder={placeholder}
          {...input}
          {...config}
          autoComplete='off' />
        {validationSpan}
      </div>
    </div>
  );
};
